/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseMessageCreateDTO interface.
 */
export function instanceOfWarehouseCaseMessageCreateDTO(value) {
    return true;
}
export function WarehouseCaseMessageCreateDTOFromJSON(json) {
    return WarehouseCaseMessageCreateDTOFromJSONTyped(json, false);
}
export function WarehouseCaseMessageCreateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'body': json['body'] == null ? undefined : json['body'],
        'attachmentId': json['attachmentId'] == null ? undefined : json['attachmentId'],
    };
}
export function WarehouseCaseMessageCreateDTOToJSON(json) {
    return WarehouseCaseMessageCreateDTOToJSONTyped(json, false);
}
export function WarehouseCaseMessageCreateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'body': value['body'],
        'attachmentId': value['attachmentId'],
    };
}
